import { PROCESS_STEPS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const ProcessTimeline = () => {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid="process-section"
            className="py-24 md:py-40 bg-samora-bone"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="text-center max-w-3xl mx-auto mb-20 md:mb-32 reveal">
                    <p className="eyebrow mb-6">Our Process</p>
                    <h2
                        className="font-display text-samora-ink leading-[0.95] tracking-tight"
                        style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
                    >
                        Eight steps.<br />
                        <span className="italic font-serif text-samora-gold">
                            One home.
                        </span>
                    </h2>
                    <p className="mt-6 text-samora-text/70 text-base md:text-lg leading-relaxed">
                        From the first conversation to the last light switch —
                        this is exactly how a Samora home is made.
                    </p>
                </div>

                <div className="relative max-w-5xl mx-auto">
                    {/* Vertical spine */}
                    <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-samora-ink/15 md:-translate-x-1/2" />

                    <div className="space-y-16 md:space-y-24">
                        {PROCESS_STEPS.map((s, i) => {
                            const isLeft = i % 2 === 0;
                            return (
                                <div
                                    key={s.step}
                                    data-testid={`process-step-${s.step}`}
                                    className={`relative reveal grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-16 items-center ${
                                        isLeft ? "" : "md:direction-rtl"
                                    }`}
                                >
                                    {/* Node */}
                                    <div className="absolute left-6 md:left-1/2 md:-translate-x-1/2 -translate-x-1/2 flex items-center justify-center z-10">
                                        <div className="w-3 h-3 bg-samora-gold rounded-full" />
                                        <div className="absolute w-8 h-8 border border-samora-gold/40 rounded-full animate-pulse" />
                                    </div>

                                    {/* Text side */}
                                    <div
                                        className={`pl-16 md:pl-0 ${
                                            isLeft
                                                ? "md:text-right md:pr-16"
                                                : "md:col-start-2 md:pl-16"
                                        }`}
                                    >
                                        <span className="font-serif text-samora-gold text-lg">
                                            Step {s.step}
                                        </span>
                                        <h3 className="font-display text-3xl md:text-4xl text-samora-ink mt-2">
                                            {s.title}
                                        </h3>
                                        <p className="mt-3 text-samora-text/70 text-sm md:text-base leading-relaxed max-w-md md:inline-block">
                                            {s.desc}
                                        </p>
                                    </div>
                                    {/* Spacer / opposite side kept empty for alternating layout */}
                                    <div
                                        className={`${
                                            isLeft
                                                ? "hidden md:block"
                                                : "hidden md:block md:col-start-1 md:row-start-1"
                                        }`}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessTimeline;
